import { Building } from '../types';

export const mockBuildings: Building[] = [
  {
    id: 'bldg-001',
    name: 'Main Campus',
    code: 'MAIN',
    address: '100 School Drive',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'bldg-002',
    name: 'East Elementary',
    code: 'EAST',
    address: '200 East Avenue',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'bldg-003',
    name: 'West Middle School',
    code: 'WEST',
    address: '300 West Boulevard',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'bldg-004',
    name: 'North High School',
    code: 'NORTH',
    address: '400 North Street',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'bldg-005',
    name: 'Athletic Complex',
    code: 'ATH',
    address: '500 Sports Lane',
    isActive: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
];

let buildings = [...mockBuildings];

export const getBuildings = (): Building[] => {
  return [...buildings];
};

export const getActiveBuildings = (): Building[] => {
  return buildings.filter(b => b.isActive);
};

export const getBuildingById = (id: string): Building | undefined => {
  return buildings.find(b => b.id === id);
};

export const addBuilding = (building: Omit<Building, 'id' | 'createdAt' | 'updatedAt'>): Building => {
  const newBuilding: Building = {
    ...building,
    id: `bldg-${Date.now()}`,
    createdAt: new Date(),
    updatedAt: new Date(),
  };
  buildings.push(newBuilding);
  return newBuilding;
};

export const updateBuilding = (id: string, updates: Partial<Omit<Building, 'id' | 'createdAt'>>): Building | undefined => {
  const index = buildings.findIndex(b => b.id === id);
  if (index === -1) return undefined;

  buildings[index] = {
    ...buildings[index],
    ...updates,
    updatedAt: new Date(),
  };
  return buildings[index];
};

export const deleteBuilding = (id: string): boolean => {
  const index = buildings.findIndex(b => b.id === id);
  if (index === -1) return false;
  buildings.splice(index, 1);
  return true;
};
